module.exports = __webpack_public_path__ + "static/19-box-stack-2af27ea9282ceac8a94bc1dc034b0001.png";